import { css } from '@emotion/react'
import { Colours, Fonts } from '../../../../style_helpers'

const applyStroke = (size, colour = Colours('grey', '500')) => {
  return `
    -${size} -${size} 0 ${colour},
    0 -${size} 0 ${colour},
    ${size} -${size} 0 ${colour},
    ${size} 0 0 ${colour},
    ${size} ${size} 0 ${colour},
    0 ${size} 0 ${colour},
    -${size} ${size} 0 ${colour},
    -${size} 0 0 ${colour}
  `
}

const applyShadow = (colour = Colours('grey', '500')) => {
  return `
    -6px 2px 0 ${colour},
    -6px 6px 0 ${colour},
    -5px 6px 0 ${colour},
    -4px 6px 0 ${colour},
    -3px 6px 0 ${colour},
    -2px 6px 0 ${colour}
  `
}

const base = (colour = Colours('grey', '500')) => css`
  margin: 0;
  font-family: ${Fonts('gibsonBold')};
  line-height: 1.25em;
  color: ${colour};
`

const outline = (colour = Colours('white'), outlineColour) => css`
  padding-left: 4px;
  color: ${colour};
  text-shadow: ${applyShadow(outlineColour)}, ${applyStroke('2px', outlineColour)};
`

export default {
  base,
  outline
}
